export default __webpack_public_path__ + "static/media/ihub.285e094e.jpg";